<template>
    <b-modal
        centered
        :visible="show"
        hide-footer
        hide-header
        no-close-on-backdrop
        no-close-on-esc
    >
    <b-container>
      <b-row>
        <b-col>
          <h5 class="text-info">{{ $t("globals.change_company") }}:</h5>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-form-select
          style="max-width: 250px"
          v-model="selected_company"
          :options="companies"
          value-field="id"
          text-field="name"
          />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn size="sm" variant="success" @click="save" >
            {{ $t("globals.save") }}
          </b-btn>
        </b-col>
        <b-col>
          <b-btn class="float-right" size="sm" @click="close" variant="warning">
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
    </b-modal>
  </template>

  <script>
  import { mapMutations, mapActions } from "vuex";
  
  export default {
    props: {
      show: Boolean,
      close: Function
    },
    components: {
      
    },
    data() {
      return {
        companies: [],
        selected_company: null
      };
    },
    methods: {
      ...mapMutations(["setShowLoadingModal"]),
      ...mapActions("axios_mod", ["simpleMutation", "simpleWebAppFetch"]),
      
      fetchCompanies() {
        const data = {
          query: `
          query  {
            CompaniesAll {
              id
              name
            }
          }
        `
        };
        this.setShowLoadingModal(true);
        this.simpleWebAppFetch({ data, this_ref: this })
          .then(res => {
            if (res) {
              this.companies.push(... res.CompaniesAll);
            }
          })
          .finally(() => {
            this.setShowLoadingModal(false);
          });
      },
      save() {
        let data = {
          query: `
            mutation { 
              res: InquiryUpdateCompany (
                inquiry_id: ${parseInt(this.$route.params.id)},
                company_id: ${parseInt(this.selected_company)}
              )
            }
          `
        };

        this.simpleMutation({ data, this_ref: this }).then(() => {
          this.new_agent_id = 0;
          this.close();
        });
      }
    },
    mounted() {
      
      this.fetchCompanies();
    }
  };
  </script>
  